import * as c from "./constant";

export const updateDateRange = ({after, before}) => ({
  type: c.UPDATE_DATE_RANGE,
  range: { after, before }
});

export const clearFilter = () => ({
  type: c.CLEAR_FILTER,
});
